import { Star } from "lucide-react";
import PageShell from "@/components/site/PageShell";
import PageHero from "@/components/site/PageHero";
import ReviewsSlider from "@/components/site/ReviewsSlider";
import GoogleReviewsWidget from "@/components/site/GoogleReviewsWidget";
import BookingCTA from "@/components/home/BookingCTA";
import { Reveal } from "@/components/site/Reveal";
import { REVIEWS } from "@/data/content";
import { SITE } from "@/data/site";

export default function Reviews() {
  return (
    <PageShell testId="reviews-page">
      <PageHero
        overline="Guest Stories"
        title={["Words From", "The Mist"]}
        subtitle="Real experiences from guests who found their calm at Vruksha Valley."
        image={SITE.heroImage}
      />

      <ReviewsSlider heading={false} />

      <GoogleReviewsWidget />

      <section className="bg-forest py-8 text-ivory">
        <div className="mx-auto grid max-w-[1400px] gap-8 px-5 py-10 text-center sm:grid-cols-3 md:px-10">
          <div><p className="font-serif text-5xl text-gold">4.9</p><p className="mt-2 text-ivory/70">Average rating</p></div>
          <div><p className="font-serif text-5xl text-gold">500+</p><p className="mt-2 text-ivory/70">Happy guests</p></div>
          <div><p className="font-serif text-5xl text-gold">100%</p><p className="mt-2 text-ivory/70">Would return</p></div>
        </div>
        <div className="pb-10 text-center">
          <a
            href={SITE.googleReviews}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="google-reviews-btn"
            className="inline-flex items-center gap-2.5 rounded-full bg-champagne px-7 py-3.5 text-sm font-medium text-forest transition-all duration-300 hover:-translate-y-0.5 hover:bg-ivory"
          >
            <Star className="h-4 w-4 fill-forest text-forest" /> Read Our Google Reviews
          </a>
        </div>
      </section>

      <section className="bg-ivory py-14 md:py-20">
        <div className="mx-auto max-w-[1400px] px-5 md:px-10">
          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {REVIEWS.map((r, i) => (
              <Reveal key={i} delay={(i % 3) * 0.08} className="rounded-2xl border border-charcoal/10 bg-card p-8 shadow-[0_8px_30px_rgba(26,54,38,0.05)]">
                <div className="flex gap-1 text-gold">
                  {Array.from({ length: r.rating }).map((_, k) => <Star key={k} className="h-4 w-4 fill-current" />)}
                </div>
                <blockquote className="mt-5 font-serif text-xl font-light leading-snug text-forest">“{r.text}”</blockquote>
                <p className="mt-6 text-sm"><span className="font-medium text-charcoal">{r.name}</span><span className="text-charcoal/50"> · {r.from}</span></p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <BookingCTA />
    </PageShell>
  );
}
